import { Formik, FieldArray } from "formik";
import { Button, CardBody, Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import * as Yup from 'yup';
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { Loader } from "../Utils/Loader";
import { addPeerConfiguration } from "../../slices/PeerConfiguration/AddPeerConfiguration/thunk";
import { editPeerConfiguration } from "../../slices/PeerConfiguration/UpdatePeerConfiguration/thunk";
import SelectField from "../Utils/SelectField";
import { LabelText } from "../Utils/Input";
import InputField from "../Utils/InputField";
import CommonButton from "../Utils/CommonButton";

export const PeerConfigurationForm = ({ toggleModals, setModalOpen, initialData, isEditMode, rating }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const peerOptions = rating ? rating.map(item => ({
        value: item.peerName,
        label: item.peerName
    })) : [];

    const alternativePeerOptions = [];
    if (rating) {
        rating.forEach(item => {
            if (item.alternativePeerNames && Array.isArray(item.alternativePeerNames)) {
                item.alternativePeerNames.forEach(altName => {
                    alternativePeerOptions.push({
                        value: altName,
                        label: altName
                    });
                });
            }
        });
    }

    const combinedOptions = [...peerOptions, ...alternativePeerOptions];
    const allPeerOptions = combinedOptions.filter((option, index, self) =>
        index === self.findIndex((t) => t.value === option.value)
    );

    let initialValues = {
        peerName: isEditMode ? initialData.peerName : "",
        alternatePeers: isEditMode
            ? (initialData.alternativePeerNames && initialData.alternativePeerNames.length > 0
                ? initialData.alternativePeerNames
                : [""])
            : [""]
    };

    const validationSchema = Yup.object().shape({
        peerName: Yup.string().required("Peer Name is required"),
        // alternatePeers: Yup.array()
        //     .of(
        //         Yup.string().required("Alternate Peer Name is required")
        //     )
        //     .min(1, "At least one alternate peer is required")
    });

    useEffect(() => {
        if (isEditMode && initialData && allPeerOptions.length > 0) {
        }
    }, [isEditMode, initialData, allPeerOptions]);

    // const getFilteredAlternateOptions = (currentPeerName, allAlternatePeers, currentIndex) => {
    //     let filteredOptions = allPeerOptions.filter(option => option.value !== currentPeerName);

    //     if (allAlternatePeers && Array.isArray(allAlternatePeers)) {
    //         allAlternatePeers.forEach((peer, index) => {
    //             if (peer && index !== currentIndex) {
    //                 filteredOptions = filteredOptions.filter(option => option.value !== peer);
    //             }
    //         });
    //     }

    //     return filteredOptions;
    // };

    const getFilteredAlternateOptions = (currentPeerValues, allAlternatePeers) => {
        const allSelected = allAlternatePeers.flat();
        const valuesToExclude = allSelected.filter(value => !currentPeerValues.includes(value));
        const filteredOptions = allPeerOptions.filter(
            option => !valuesToExclude.includes(option.value)
        );

        return filteredOptions;
    };

    return (
        <div>
            <Formik
                validationSchema={validationSchema}
                initialValues={initialValues}
                onSubmit={async (values) => {
                    const filteredAlternatePeers = values.alternatePeers.filter(peer => peer && peer.trim() !== "");

                    const payload = {
                        peerName: values.peerName,
                        alternativePeerNames: filteredAlternatePeers,
                    };
                    if (!isEditMode) {
                        dispatch(addPeerConfiguration(payload, setLoading, setModalOpen))
                    } else {
                        dispatch(editPeerConfiguration(
                            payload,
                            initialData?.peerName,
                            setLoading,
                            setModalOpen
                        ))
                    }
                }}
            >
                {({
                    handleChange,
                    handleSubmit,
                    errors,
                    touched,
                    values,
                    setFieldValue,
                }) => (
                    <Form onSubmit={handleSubmit}>
                        {loading && <Loader />}
                        <Row>
                            <Col className="mb-4" lg={12}>
                                <LabelText
                                    htmlFor="peerName"
                                    classLabelName={"ms-0 rv-form-label"}
                                    className={"text-danger"}
                                    displayText="Peer Name"
                                    important={"*"}
                                />
                                <LabelText
                                    htmlFor="peerName"
                                    classLabelName={`d-block ms-0 rv-sub-label ${(touched.peerName && errors.peerName)
                                        ? "rv-label-danger"
                                        : "rv-label-muted"
                                        } `}
                                    displayText={"Enter Peer Name"}
                                />
                                <InputField
                                    name="peerName"
                                    type="text"
                                    className={"form-control"}
                                    handleChange={(e) => {
                                        const newPeerName = e.target.value;
                                        handleChange(e);
                                        const conflictingIndices = values.alternatePeers.findIndex(
                                            peer => peer === newPeerName
                                        );

                                        if (conflictingIndices !== -1) {
                                            const updatedAlternatePeers = [...values.alternatePeers];
                                            updatedAlternatePeers[conflictingIndices] = "";
                                            setFieldValue("alternatePeers", updatedAlternatePeers);
                                        }
                                    }}
                                    value={values.peerName || ''}
                                    disabled={isEditMode}
                                    invalid={touched.peerName && !!errors.peerName}
                                />
                            </Col>

                            <Col lg={12}>
                                <LabelText
                                    htmlFor="alternatePeers"
                                    classLabelName={"ms-0 rv-form-label"}
                                    className={"text-danger"}
                                    displayText="Alternate Peer List"
                                />
                                <LabelText
                                    htmlFor="alternatePeers"
                                    classLabelName={`d-block ms-0 rv-sub-label ${(touched.alternatePeers && errors.alternatePeers)
                                        ? "rv-label-danger"
                                        : "rv-label-muted"
                                        } `}
                                    displayText={
                                        (touched.alternatePeers && errors.alternatePeers) ? errors.alternatePeers : "Select Alternate Peer"
                                    }
                                />
                                <SelectField
                                    placeholder={" "}
                                    className="w-100 mb-3 multi-select"
                                    closeMenuOnSelect={false}
                                    value={
                                        values.alternatePeers
                                            ? allPeerOptions.filter((option) => values.alternatePeers.includes(option.value))
                                            : []
                                    }
                                    handleChange={(selectedOptions) => {
                                        setFieldValue(
                                            "alternatePeers",
                                            selectedOptions ? selectedOptions.map((option) => option.value) : []
                                        );
                                    }}
                                    isDisabled={loading}
                                    isMulti={true}
                                    options={getFilteredAlternateOptions(values.peerName, values.alternatePeers)}
                                    isRVStyle={true}
                                    isClearable={true}
                                />

                                {/* <FieldArray name="alternatePeers">
                                {({ remove, push, unshift }) => (
                                    <div>
                                        {values.alternatePeers.map((peer, index) => (
                                            <div key={index} className="d-flex mb-2 align-items-center">
                                                <div style={{ flex: 1 }}>
                                                    <SelectField
                                                        className="w-100"
                                                        value={
                                                            peer ? getFilteredAlternateOptions(values.peerName, [], -1).find(option => option.value === peer) : null
                                                        }
                                                        placeholder={" "}
                                                        handleChange={(selectedOption) => {
                                                            setFieldValue(`alternatePeers.${index}`, selectedOption ? selectedOption.value : "");
                                                        }}
                                                        handleBlur={() => {
                                                            if (!touched.alternatePeers) {
                                                                const newTouched = { ...touched };
                                                                newTouched.alternatePeers = [];
                                                                newTouched.alternatePeers[index] = true;
                                                            }
                                                        }}
                                                        options={getFilteredAlternateOptions(values.peerName, values.alternatePeers, index)}
                                                        isRVStyle={true}
                                                        isClearable={true}
                                                        isDisabled={loading}
                                                        labelName={`alternatePeer${index}`}
                                                    />
                                                </div>
                                                {index === 0 && values.alternatePeers[0] !== "" && (
                                                    <i
                                                        className="mdi mdi-plus-circle-outline ms-2"
                                                        style={{
                                                            fontSize: '20px',
                                                            color: values.alternatePeers[0] && values.alternatePeers[0].trim() ? '#fd625e' : '#cccccc',
                                                            cursor: values.alternatePeers[0] && values.alternatePeers[0].trim() ? 'pointer' : 'not-allowed',
                                                            opacity: values.alternatePeers[0] && values.alternatePeers[0].trim() ? 1 : 0.5
                                                        }}
                                                        onClick={() => {
                                                            if (values.alternatePeers[0] && values.alternatePeers[0].trim()) {
                                                                unshift("");
                                                            }
                                                        }}
                                                    ></i>
                                                )}
                                                {values.alternatePeers[index] !== "" && <i
                                                    className="ri ri-close-line ms-2"
                                                    style={{
                                                        fontSize: '20px',
                                                        color: values.alternatePeers.length > 1 ? '#fd625e' : '#cccccc',
                                                        cursor: values.alternatePeers.length > 1 ? 'pointer' : 'not-allowed',
                                                        opacity: values.alternatePeers.length > 1 ? 1 : 0.5
                                                    }}
                                                    onClick={() => {
                                                        if (values.alternatePeers.length > 1) {
                                                            remove(index);
                                                        }
                                                    }}
                                                ></i>}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </FieldArray> */}
                            </Col>
                        </Row>

                        {/* Submit and Cancel Buttons */}

                        <div className="d-flex gap-2 justify-content-center">
                            <div className="d-flex justify-content-center gap-2">
                                <CommonButton
                                    outline
                                    type="reset"
                                    className={
                                        "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                                    }
                                    color={"main-color"}
                                    buttonAction={toggleModals}
                                    buttonText={"Close"}
                                    icon={
                                        <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                    }
                                    btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                                />
                                <CommonButton
                                    color={"main-color"}
                                    className={
                                        "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                                    }
                                    icon={
                                        <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-2"></i>
                                    }
                                    btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                                    type="submit"
                                    buttonText={"Submit"}
                                />
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div >
    );
};